/* unplugin-vue-components disabled */import { render } from "./expanded.vue?vue&type=template&id=154e657d&scoped=true"
import script from "./expanded.vue?vue&type=script&lang=js"
export * from "./expanded.vue?vue&type=script&lang=js"

import "./expanded.vue?vue&type=style&index=0&id=154e657d&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-154e657d"],['__file',"src/components/ai-chat/ai-assistant/expanded.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "154e657d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('154e657d', __exports__)) {
    api.reload('154e657d', __exports__)
  }
  
  module.hot.accept("./expanded.vue?vue&type=template&id=154e657d&scoped=true", () => {
    api.rerender('154e657d', render)
  })

}


export default __exports__